import(/* webpackMode: "eager" */ "/codebuild/output/src820538367/src/SkillBridger/src/app/global-error.tsx");
